module.exports = __webpack_public_path__ + "assets/howtoinschrijven.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/howtoinschrijven.jpg
// module id = 363
// module chunks = 0